"use client";

import { Image, ImageSizes, Input, Text, View } from "@/components";
import cn from "@/utils/cn";

import type { CheckboxProps } from "@/components/types";
import type { JSX } from "react";

const Checkbox = ({
  label,
  img,
  size = "1x",
  name,
  dir = "row",
  className,
  ...props
}: CheckboxProps): JSX.Element => {
  const margin =
    dir === "row"
      ? { marginRight: ImageSizes[size] / 2 }
      : { marginBottom: ImageSizes[size] / 2 };

  return (
    <View className={`flex flex-${dir} items-center`}>
      <Input
        id={name}
        name={name}
        type="checkbox"
        defaultChecked={false}
        className={cn("cursor-pointer", className)}
        style={{
          width: ImageSizes[size],
          height: ImageSizes[size],
          ...(label && margin)
        }}
        {...props}
      />
      {label && (
        <Text
          type="label"
          htmlFor={name}
          className="font-medium flex items-center gap-2 cursor-pointer select-none"
        >
          {img && (
            <Image
              src={img}
              alt={label ?? ""}
              width={ImageSizes[size]}
              height={ImageSizes[size]}
            />
          )}
          {label}
        </Text>
      )}
    </View>
  );
};

export default Checkbox;
